import gql from 'graphql-tag';

export const weddingQuery = gql`
  query weddingQuery {
    wedding {
      id
      weddingDate
      budgetRange
      guestRange
      market {
        city
        state
        country
        code
      }
    }
  }
`;
